import React from "react";
import Countdown from "react-countdown";
import { withRouter } from "react-router-dom";
import backImage from "../images/type.jpeg";

const Start = withRouter(props => {
  const handleComplete = () => {
    props.history.push("/game");
  };

  const style = {
    margin: "0 auto",
    fontSize: "10rem",
    width: "100%",
    height: "calc(100vh - 50px - 50px)",
    textAlign: "center",
    backgroundImage: `url(${backImage}`,
    backgroundColor: "rgba(255,255,255,0.7)",
    backgroundBlendMode: "lighten",
    backgroundPosition: "bottom",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  const circleStyle = {
    padding: "20px 50px",
    color: "#666666",
    fontSize: "3rem",
    textAlign: "center",
    verticalAlign: "middle",
    border: "solid 5px rgba(255,165,0,0.7)",
    margin: "0px auto 30px",
    backgroundColor: "rgba(255,255,255,0.7)",
    borderRadius: "80px"
  };

  const renderer = ({ seconds }) => {
    return (
      <div style={style}>
        <span style={circleStyle}>{seconds}</span>
      </div>
    );
  };

  return (
    <Countdown
      date={Date.now() + 3000}
      renderer={renderer}
      onComplete={handleComplete}
    ></Countdown>
  );
});

export default Start;
